import React from "react";
var __jsx = React.createElement;
import { Configure as BaseConfigure } from 'react-instantsearch-dom';
import { PageStatus } from '@uno/common-cms';
import { useSiteConfig } from 'libs/common/hooks';

var Configure = function Configure(_ref) {
  var hitsPerPage = _ref.hitsPerPage,
      _ref$facetFilters = _ref.facetFilters,
      facetFilters = _ref$facetFilters === void 0 ? [] : _ref$facetFilters,
      filters = _ref.filters;

  var _useSiteConfig = useSiteConfig(),
      site = _useSiteConfig.id;

  var defaultFilters = ["site:".concat(site), "NOT pageStatus:".concat(PageStatus.Killed), "NOT pageStatus:".concat(PageStatus.Redirected)];

  if (filters !== undefined) {
    defaultFilters.push(filters);
  }

  return __jsx(BaseConfigure, {
    hitsPerPage: hitsPerPage,
    filters: defaultFilters.join(' AND '),
    facetFilters: facetFilters
  });
};

export default Configure;